<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiCircleEditOutline } from "@mdi/js";
export default {
  name: "MdiEdit",
  data() {
    return {
      svgPath: mdiCircleEditOutline,
    };
  },
};
</script>
